export enum OccurrenceTypeEnum {
  Academic = 1,
  Disciplinary = 2,
  FrequencyControl = 3,
  Congratulations = 4,
}
